import Vue from 'vue'
import 'whatwg-fetch'

const state = Vue.observable({})
const defaultLangcode = 'en'

/**
 * Translate plugin.
 */
const Translate = {}
Translate.install = function () {
  Vue.set(state, '_language', defaultLangcode)
  Vue.set(state, '_translations', {})

  Vue.prototype.$getLanguage = function () {
    return state._language
  }

  Vue.prototype.$setLanguage = function (langcode) {
    Vue.set(state, '_language', langcode)
  }

  /**
   * Translation function. Vue components should call $t(string) or
   * this.$t(string) with the English string to be translated.
   */
  Vue.prototype.$t = function (string) {
    const langcode = state._language

    if (langcode === 'en') {
      // English doesn't need translation.
      return string
    }

    if (typeof state._translations[langcode] === 'undefined') {
      // No translations available yet.
      // Initalize state properties.
      Vue.set(state._translations, langcode, {})
      Vue.set(state._translations[langcode], string, '')

      // Translations are retrieved via a compiled json file mapping English to
      // target language strings.
      fetch(`translations/${langcode}.json`)
        .then((response) => {
          if (response.status === 200) {
            return response.json()
          }
          if (response.status === 404) {
            // eslint-disable-next-line
            console.error(`Could not load translation file for ${langcode}`)
          }
          return {}
        })
        .then((result) => {
          // Update all translations for the langcode.
          Vue.set(state._translations, langcode, result)
          return state._translations[langcode][string]
        })
        .catch(function (error) {
          // eslint-disable-next-line
          console.error(error)
          return string
        })
    }

    if (typeof state._translations[langcode][string] !== 'undefined' && state._translations[langcode][string] !== '') {
      // For non-specified or empty translations, return the observable string
      // object in case it gets updated at a later time.
      return state._translations[langcode][string]
    }

    // Fallback.
    return string
  }
}

Vue.use(Translate)
